"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ShapeType;
(function (ShapeType) {
    ShapeType[ShapeType["EMPTY"] = 0] = "EMPTY";
    ShapeType[ShapeType["GROUP"] = 1] = "GROUP";
    ShapeType[ShapeType["IMAGE"] = 2] = "IMAGE";
    ShapeType[ShapeType["LINE"] = 3] = "LINE";
    ShapeType[ShapeType["SHAPE"] = 4] = "SHAPE";
    ShapeType[ShapeType["TEXT"] = 5] = "TEXT";
})(ShapeType = exports.ShapeType || (exports.ShapeType = {}));
//# sourceMappingURL=interfaces.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/PRO/Documents/GitHub/CGStore-Front/node_modules/ngvas/lib/canvas/shapes/interfaces.js
// module id = ../../../../ngvas/lib/canvas/shapes/interfaces.js
// module chunks = vendor